module.exports = __webpack_public_path__ + "img/like.edeae202.svg";